<h2 mat-dialog-title>{{dialogTitle}}</h2>
<form [formGroup]="editUsernameForm">
  <mat-dialog-content>
    @if (orgHasintegration) {
      <mat-form-field appearance="outline" class="w-full">
        <mat-label i18n>Would you like to also edit this account in your CRM?</mat-label>
        <input type="checkbox" matInput formControlName="useIntegration" required>
      </mat-form-field>
    }
    <mat-form-field appearance="outline" class="w-full">
      <mat-label>{{ label }}</mat-label>
      <input matInput formControlName="newUsername" required autocomplete="username" />
      @if (editUsernameForm.get('newUsername')?.hasError('required')) {
        <mat-error i18n>Username is required</mat-error>
      }
    </mat-form-field>
  </mat-dialog-content>

  <mat-dialog-actions>
    <ul class="list-inline list-unstyled">
      <li>
        <button class="btn btn-primary" type="submit" [disabled]="editUsernameForm.invalid" (click)="onSubmit()" i18n>Change</button>
      </li>
      <li>
        <button class="btn btn-warning btn-outline" (click)="onCancel()" i18n>Cancel</button>
      </li>
    </ul>
  </mat-dialog-actions>
</form>
